module.exports = __webpack_public_path__ + "img/next-loot-3.a92e6cf9.png";